import * as React from "react";
import { useMediaQuery } from "@material-ui/core";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton,
  Edit,
  Create,
  SimpleForm,
  SelectInput,
  TextInput,
  SimpleList,
  BooleanField,
  DateField,
  NumberField,
  BooleanInput,
  DateInput,
  NumberInput,
  ReferenceInput,
  Title,
  Labeled,
} from "react-admin";
import { FunctionField } from 'react-admin';

import { useNotify, useRecordContext, useGetOne, useRedirect, RecordContextProvider, SimpleShowLayout, Show, TabbedShowLayout  } from 'react-admin';
import { useGetManyReference  } from 'react-admin';
import { useWatch } from 'react-hook-form';

import { Card } from '@mui/material';
import { Button } from '@mui/material';
import { TextField as MuiTextField } from '@mui/material';
import { IconButton } from '@mui/material';
import { InputAdornment } from '@mui/material';
import { Checkbox } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { MenuItem } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ContentCopy from '@mui/icons-material/ContentCopy';
import EditIcon from '@mui/icons-material/Edit';
import { fetchUtils } from 'react-admin';
import inMemoryJWT from './inMemoryJWT';
import axios from 'axios';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import OnlineStatus  from './components/OnlineStatus';
import LastSeen  from './components/LastSeen';
import SelectFirmware  from './components/SelectFirmware';
import WifiMode  from './components/WifiMode';
import SelectPatch from './components/SelectPatch';
import { apiBaseUrl, deviceControlApiUrl, grafanaBaseUrl } from './config';

const deviceFilters = [
  <TextInput source="q" label="Search" alwaysOn />,
  <SelectInput source="health_filter" label="Health" alwaysOn choices={[
    { id: "abnormal", name: "Abnormal" },
    { id: "normal", name: "Normal" },
    { id: "camera_issue", name: "Camera Issue" },
    { id: "disk_issue", name: "Disk Issue" },
    { id: "configuration_mismatch", name: "Configuration Mismatch" },
  ]} />,
];

const IsOnline = props => {
};

export const DeviceList = (props) => (
    <List filters={deviceFilters} perPage={50} {...props}>
        <Datagrid rowClick="show">
            <TextField source="device_id" />
            <OnlineStatus label="Online" source="last_update_ts" />
            <LastSeen label="Last Seen" source="last_update_ts"/>
            <TextField label="LTE IP" source="lte_ip" />
            <TextField label="Version" source="app_ver" />
            <TextField label="APN" source="apn" />
            <TextField label="CPU_ID" source="cpu_id" />
            <TextField label="IMEI" source="imei" />
            <TextField label="SIM_ID" source="iccid" />
            <TextField label="Patch Version" source="patch_ver" />
            <FunctionField label="Health" render={record => formatHealthStatus(record.health_status)} />
            <FunctionField label="Health Issues" render={record => formatHealthIssueKeys(record.health_issue_keys)} />
            <TextField label="Uptime" source="uptime_str"/>
            <NumberField label="GPS Lock" source="gps_lock" />
        </Datagrid>
    </List>
);

export const DeviceEdit = () => (
    <div>
    <TextField source="device_id" />
    <TextField source="lte_ip" />
    <TextField source="app_ver" />
    <TextField source="apn" />
    <TextField source="cpu_id" />
    <TextField source="imei" />
    <TextField source="iccid" />
    <DateField source="last_update_ts" />
    <TextField source="sn" />
    <NumberField source="uptime" />
    <NumberField source="gps_lock" />
    <Edit>
        <SimpleForm>
        </SimpleForm>
    </Edit>
    </div>
);

export const RebootButton = (props) => {
   const record = useRecordContext();
   const notify = useNotify();
   const handleClick = () => {
        const token = inMemoryJWT.getToken();
        if (!token) {
            console.log("No token found");
            return;
        }

        if (!window.confirm("Are you sure you want to reboot device : " + record.device_id + "?")) {
            return;
        }

        var post_data = {};
        post_data.device_id = record.device_id;
        axios.post(deviceControlApiUrl + 'reboot', post_data, {
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            console.log(response);
            notify("Request to Reboot Device : " + record.device_id, { type: 'success' });
        }).catch(function (error) {
            notify("Request to Reboot Device : " + record.device_id + " failed :" + error, { type: 'error' });
        });
   };
   return <Button variant="contained" onClick={handleClick} {...props}>Reboot</Button>;
};

export const FactoryResetButton = (props) => {
   const record = useRecordContext();
   const notify = useNotify();
   const handleClick = () => {
        const token = inMemoryJWT.getToken();
        if (!token) {
            console.log("No token found");
            return;
        }

        if (!window.confirm("Are you sure you want to Factory Reset device : " + record.device_id + "?")) {
            return;
        }

        var post_data = {};
        post_data.device_id = record.device_id;
        axios.post(deviceControlApiUrl + 'factory_reset', post_data, {
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            console.log(response);
            notify("Request to Factory Reset Device : " + record.device_id, { type: 'success' });
        }).catch(function (error) {
            notify("Request to Factory Reset Device : " + record.device_id + " failed :" + error, { type: 'error' });
        });
   };
   return <Button variant="contained" onClick={handleClick} {...props}>Factory Reset</Button>;
};

export const FormatSDCardButton = (props) => {
   const record = useRecordContext();
   const notify = useNotify();
   const handleClick = () => {
        const token = inMemoryJWT.getToken();
        if (!token) {
            console.log("No token found");
            return;
        }

        if (!window.confirm("Are you sure you want to format SD card of device : " + record.device_id + "?")) {
            return;
        }

        var post_data = {};
        post_data.device_id = record.device_id;
        axios.post(deviceControlApiUrl + 'format_sdcard', post_data, {
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            console.log(response);
            notify("Request to FormatSDCard Device : " + record.device_id, { type: 'success' });
        }).catch(function (error) {
            notify("Request to FormatSDCard Device : " + record.device_id + " failed :" + error, { type: 'error' });
        });
   };
   return <Button variant="contained" onClick={handleClick} {...props}>Format SDCard</Button>;
};

export const GsensorCalibrationRestartButton = (props) => {
   const record = useRecordContext();
   const notify = useNotify();
   const handleClick = () => {
        const token = inMemoryJWT.getToken();
        if (!token) {
            console.log("No token found");
            return;
        }

        if (!window.confirm("Are you sure you want to reset g-sensor calibration for device : " + record.device_id + "?")) {
            return;
        }

        var post_data = {};
        post_data.device_id = record.device_id;
        axios.post(deviceControlApiUrl + 'gsensor_calibration_restart', post_data, {
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            console.log(response);
            notify("Request to Reset Calibration for Device : " + record.device_id, { type: 'success' });
        }).catch(function (error) {
            notify("Request to Reset Calibration for Device : " + record.device_id + " failed :" + error, { type: 'error' });
        });
   };
   return <Button variant="contained" onClick={handleClick} {...props}>Reset Calibration</Button>;
};

function GrafanaUrl (props) {
    const record = useRecordContext();
    if (!record) return null;
    const handleClick = () => {
	let url = `${grafanaBaseUrl}/d/2lBUwFPVk/dashcam-monitoring?orgId=1&refresh=1m&var-device_id=${record.device_id}&from=now-1h&to=now`
	window.open(url, '_blank').focus();
	return;
    };

    return <Button variant="contained" onClick={handleClick} {...props}>Open Grafana Chart</Button>;
}

function BasicTable() {
    const record = useRecordContext();
    if (!record) return null;
    return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Parameter</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Device ID </TableCell>
		      <TableCell>{record.device_id}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Last Update </TableCell>
		      <TableCell><DateField source="last_update_ts" record={record} showTime /></TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> SN </TableCell>
		      <TableCell>{record.sn}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> CPU ID </TableCell>
		      <TableCell>{record.cpu_id}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> MAC </TableCell>
		      <TableCell>{record.mac}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> IMEI </TableCell>
		      <TableCell>{record.imei}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Public IP </TableCell>
		      {record.pub_ip ? <TableCell>{record.pub_ip}</TableCell>
			          : <TableCell>"NA"</TableCell> }
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> SIM Present </TableCell>
		      {record.sim ? <TableCell>Present</TableCell>
			          : <TableCell>Not Detected</TableCell> }
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> SIM ID </TableCell>
		      <TableCell>{record.iccid}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> FW Version </TableCell>
		      <TableCell>{record.app_ver}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Patch Version </TableCell>
		      <TableCell>{record.patch_ver}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> AI Version </TableCell>
		      <TableCell>{record.ai_ver}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> MCU Version </TableCell>
		      <TableCell>{record.mcu_ver}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Bluez Version </TableCell>
		      <TableCell>{record.bluez_ver}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> OBDII SN </TableCell>
		      <TableCell>{record.obdii_sn}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> OBDII HW </TableCell>
		      <TableCell>{record.obdii_hw}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> OBDII SW </TableCell>
		      <TableCell>{record.obdii_sw}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> OBDII VIN </TableCell>
		      <TableCell>{record.obdii_vin}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> APN </TableCell>
		      <TableCell>{record.apn}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Internet Connected </TableCell>
		      {record.internet ? <TableCell>Connected</TableCell>
			          : <TableCell>Disconnected</TableCell> }
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Uptime </TableCell>
		      <TableCell>{record.uptime}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> CPU Temp </TableCell>
		      <TableCell>{record.cpu_temp}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> System voltage </TableCell>
		      <TableCell>{record.system_voltage}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> WiFi IP </TableCell>
		      <WifiMode label="Wifi Info" record={record}/>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> WiFi IP </TableCell>
		      <TableCell>{record.wifi_ip}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> WiFi SSID </TableCell>
		      <TableCell>{record.wifi_ssid}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Modem Signal </TableCell>
		      <TableCell>{record.rssi}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Modem Network Type </TableCell>
		      <TableCell>{record.network_tech}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> GPS Lock Status </TableCell>
		      {record.gps_lock ? <TableCell>Lock</TableCell>
			          : <TableCell>Not Lock</TableCell> }
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> GPS Satellite </TableCell>
		      <TableCell>{record.sat}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> ACC </TableCell>
		      <TableCell>{record.acc}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> IO </TableCell>
		      <TableCell>{record.io}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Record Status </TableCell>
		      <TableCell>{record.rec_stat}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Server1 Status </TableCell>
		      <TableCell>{record.server1_stat}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Server2 Status </TableCell>
		      <TableCell>{record.server2_stat}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Server3 Status </TableCell>
		      <TableCell>{record.server3_stat}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Server4 Status </TableCell>
		      <TableCell>{record.server4_stat}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> IO Alarm </TableCell>
		      <TableCell>{record.io_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> G-Sensor Alarm </TableCell>
		      <TableCell>{record.gsensor_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Speed Alarm </TableCell>
		      <TableCell>{record.speed_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Video Lost Alarm </TableCell>
		      <TableCell>{record.video_lost_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Voltage Alarm </TableCell>
		      <TableCell>{record.voltage_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Disk Alarm </TableCell>
		      <TableCell>{record.disk_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Motion Alarm </TableCell>
		      <TableCell>{record.motion_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Occlusion Alarm </TableCell>
		      <TableCell>{record.occlusion_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> ACC Alarm </TableCell>
		      <TableCell>{record.acc_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> GNSS Alarm </TableCell>
		      <TableCell>{record.gnss_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> RTC Alarm </TableCell>
		      <TableCell>{record.rtc_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Temp Alarm </TableCell>
		      <TableCell>{record.temp_alarm}</TableCell>
		</TableRow>
		<TableRow sx={{ backgroundColor: '#f5f5f5' }}>
		      <TableCell colSpan={2} sx={{ fontWeight: 'bold' }}>Device Diag</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SD Missing </TableCell>
		      <TableCell>{record.diag_sd_missing}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SSD Missing </TableCell>
		      <TableCell>{record.diag_ssd_missing}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SD Device </TableCell>
		      <TableCell>{record.diag_sd_dev}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SSD Device </TableCell>
		      <TableCell>{record.diag_ssd_dev}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SD Size </TableCell>
		      <TableCell>{record.diag_sd_size}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SSD Size </TableCell>
		      <TableCell>{record.diag_ssd_size}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SD Read Only </TableCell>
		      <TableCell>{record.diag_sd_ro}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SSD Read Only </TableCell>
		      <TableCell>{record.diag_ssd_ro}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SD RO Msg </TableCell>
		      <TableCell>{record.diag_sd_ro_msg}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SSD RO Msg </TableCell>
		      <TableCell>{record.diag_ssd_ro_msg}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SD IO Error </TableCell>
		      <TableCell>{record.diag_sd_io_error}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SSD IO Error </TableCell>
		      <TableCell>{record.diag_ssd_io_error}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SD Media Error </TableCell>
		      <TableCell>{record.diag_sd_media_error}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag SSD Media Error </TableCell>
		      <TableCell>{record.diag_ssd_media_error}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag eMMC IO Error </TableCell>
		      <TableCell>{record.diag_emmc_io_error}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag eMMC Error Msg </TableCell>
		      <TableCell>{record.diag_emmc_error_msg}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag No SIM </TableCell>
		      <TableCell>{record.diag_no_sim}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Diag Kernel Error </TableCell>
		      <TableCell>{record.diag_kernel_error}</TableCell>
		</TableRow>
		<TableRow sx={{ backgroundColor: '#f5f5f5' }}>
		      <TableCell colSpan={2} sx={{ fontWeight: 'bold' }}>QoS</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Timestamp </TableCell>
		      <TableCell>{record.qos_ts}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Interface </TableCell>
		      <TableCell>{record.qos_iface}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Rate Kbit </TableCell>
		      <TableCell>{record.qos_rate_kbit}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS TX Kbit </TableCell>
		      <TableCell>{record.qos_tx_kbit}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Avg TX Kbit </TableCell>
		      <TableCell>{record.qos_avg_tx_kbit}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Util % </TableCell>
		      <TableCell>{record.qos_util_pct}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Delay ms </TableCell>
		      <TableCell>{record.qos_delay_ms}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Avg Delay ms </TableCell>
		      <TableCell>{record.qos_avg_delay_ms}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Backlog Bytes </TableCell>
		      <TableCell>{record.qos_backlog_b}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Avg Low Count </TableCell>
		      <TableCell>{record.qos_avg_low_count}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Util Up Count </TableCell>
		      <TableCell>{record.qos_util_up_count}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Delay Bad Count </TableCell>
		      <TableCell>{record.qos_delay_bad_count}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Delay Recover Count </TableCell>
		      <TableCell>{record.qos_delay_recover_count}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Active Live </TableCell>
		      <TableCell>{record.qos_act_live}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Record Suppress </TableCell>
		      <TableCell>{record.qos_rec_supr}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Min Required Kbit </TableCell>
		      <TableCell>{record.qos_min_required_kbit}</TableCell>
		</TableRow>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> QoS Port 6040 Limit Kbit </TableCell>
		      <TableCell>{record.qos_port6040_limit_kbit}</TableCell>
		</TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function FirmwareUpgrade() {
	const record = useRecordContext();
	if (!record) return null;
	return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>FW</TableCell>
            <TableCell>Current Version</TableCell>
            <TableCell>Upgrade FW</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Main Firmware </TableCell>
		      <TableCell>{record.app_ver}</TableCell>
		      <TableCell><SelectFirmware fw_type="fw" /></TableCell>
		</TableRow>
        </TableBody>
        <TableBody>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> AI Firmware </TableCell>
		      <TableCell>{record.ai_ver}</TableCell>
		      <TableCell><SelectFirmware fw_type="ai_fw" /></TableCell>
		</TableRow>
        </TableBody>
		<TableBody>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Modem Firmware </TableCell>
		      <TableCell>{record.modem_ver}</TableCell>
		      <TableCell><SelectFirmware fw_type="modem_fw" /></TableCell>
		</TableRow>
        </TableBody>
        <TableBody>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
		      <TableCell component="th" scope="row"> Patch Script </TableCell>
		      <TableCell>{record.patch_ver}</TableCell>
		      <TableCell><SelectPatch /></TableCell>
		</TableRow>
        </TableBody>
      </Table>
    </TableContainer>
	);
}

function DeviceTaskList()
{
	const record = useRecordContext();
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);

	React.useEffect(() => {
		setPage(0);
	}, [record && record.device_id]);

	/* useGetManyReference will call to tasks.getManyReference({"target_filed":"id_field")} */
	const { data, isLoading, error, total } = useGetManyReference(
		'tasks',
		{ 
			target: 'device_id',
			id : record.device_id,
			pagination: { page: page + 1, perPage: rowsPerPage },
			sort: { field: 'submit_ts', order: 'DESC' },
		}
		);
	if (isLoading) { return <p>Loading</p>; }
	if (error) { return <p>ERROR</p>; }
	return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Task Type</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Submit Time</TableCell>
            <TableCell>Complete Time</TableCell>
            <TableCell>Complete Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
		{data.map(task => (
			<TableRow key={task.id || task._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
			      <TableCell component="th" scope="row"> {task.task_type} </TableCell>
			      <TableCell>{task.description || "-"}</TableCell>
			      <TableCell>{task.status}</TableCell>
			      <TableCell>{task.submit_ts}</TableCell>
			      <TableCell>{task.finish_ts || task.complete_ts}</TableCell>
			      <TableCell>{task.result ? task.result.verbose : "-"}</TableCell>
			</TableRow>
		))}
        </TableBody>
      </Table>
	  <TablePagination
		component="div"
		count={total || 0}
		page={page}
		onPageChange={(event, newPage) => setPage(newPage)}
		rowsPerPage={rowsPerPage}
		onRowsPerPageChange={(event) => {
			setRowsPerPage(parseInt(event.target.value, 10));
			setPage(0);
		}}
		rowsPerPageOptions={[10, 25, 50]}
	  />
    </TableContainer>
	       );
}

function DefaultPasswordsTab() {
    const record = useRecordContext();
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [passwords, setPasswords] = React.useState(null);
    const [showAdmin, setShowAdmin] = React.useState(false);
    const [showRoot, setShowRoot] = React.useState(false);

    const fallbackCopy = (value) => {
        var textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        var success = false;
        try {
            success = document.execCommand('copy');
        } catch (err) {
            success = false;
        }
        document.body.removeChild(textarea);
        return success;
    };

    const copyToClipboard = (value, label) => {
        if (!value) return;
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(value).then(function () {
                notify(label + " copied", { type: 'success' });
            }).catch(function () {
                var ok = fallbackCopy(value);
                if (ok) {
                    notify(label + " copied", { type: 'success' });
                } else {
                    notify("Copy failed", { type: 'error' });
                }
            });
        } else {
            var ok = fallbackCopy(value);
            if (ok) {
                notify(label + " copied", { type: 'success' });
            } else {
                notify("Clipboard not available", { type: 'error' });
            }
        }
    };

    const handleResetPassword = () => {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: 'error' });
            return;
        }
        if (!window.confirm("Are you sure you want to reset password for device: " + record.device_id + "?")) {
            return;
        }
        var post_data = {};
        post_data.device_id = record.device_id;
        axios.post(deviceControlApiUrl + 'reset_passwd', post_data, {
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        }).then(function () {
            notify("Request to reset password: " + record.device_id, { type: 'success' });
        }).catch(function (err) {
            var msg = err && err.message ? err.message : String(err);
            notify("Reset password failed: " + msg, { type: 'error' });
        });
    };

    React.useEffect(() => {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            setError("No token found");
            return;
        }
        setLoading(true);
        setError(null);
        setPasswords(null);
        var post_data = {};
        post_data.device_id = record.device_id;
        post_data.id = 0;
        axios.post(deviceControlApiUrl + 'get_passwords', post_data, {
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            var data = response && response.data ? response.data : null;
            if (!data) {
                setError("Invalid response");
                return;
            }
            if (data.error) {
                setError(data.error);
                notify("Get default passwords failed: " + data.error, { type: 'error' });
                return;
            }
            setPasswords(data.result || {});
        }).catch(function (err) {
            var msg = err && err.message ? err.message : String(err);
            setError(msg);
            notify("Get default passwords failed: " + msg, { type: 'error' });
        }).finally(function () {
            setLoading(false);
        });
    }, [record, notify]);

    if (!record) return null;

    return (
        <Card style={{ padding: '16px', maxWidth: 640 }}>
            <div style={{ marginBottom: '12px' }}>
                <Button variant="contained" onClick={handleResetPassword}>Reset Password</Button>
            </div>
            {loading && <div>Loading...</div>}
            {!loading && error && <div style={{ color: '#b00020' }}>{error}</div>}
            {!loading && !error && passwords && (
                <div>
                    <MuiTextField
                        fullWidth
                        margin="normal"
                        label="Web UI Admin Password"
                        type={showAdmin ? "text" : "password"}
                        value={passwords.WEB_ADMIN || ""}
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle admin password visibility"
                                        onClick={() => setShowAdmin(!showAdmin)}
                                        edge="end"
                                    >
                                        {showAdmin ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                    <IconButton
                                        aria-label="copy admin password"
                                        onClick={() => copyToClipboard(passwords.WEB_ADMIN || "", "Web UI admin password")}
                                        edge="end"
                                    >
                                        <ContentCopy />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    <MuiTextField
                        fullWidth
                        margin="normal"
                        label="SSH Password"
                        type={showRoot ? "text" : "password"}
                        value={passwords.ROOT || ""}
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle ssh password visibility"
                                        onClick={() => setShowRoot(!showRoot)}
                                        edge="end"
                                    >
                                        {showRoot ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                    <IconButton
                                        aria-label="copy ssh password"
                                        onClick={() => copyToClipboard(passwords.ROOT || "", "SSH password")}
                                        edge="end"
                                    >
                                        <ContentCopy />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </div>
            )}
        </Card>
    );
}

function formatHealthStatus(status) {
    if (!status) return "Unknown";
    if (status === "normal") return "Normal";
    if (status === "abnormal") return "Abnormal";
    return String(status);
}

function formatHealthIssueLabel(issueType) {
    if (issueType === "camera_not_normal") return "Camera not normal";
    if (issueType === "disk_abnormal") return "Disk abnormal";
    if (issueType === "calibration_failed") return "Calibration failed to converge";
    if (issueType === "calibration_lost") return "Calibration lost (orientation changed)";
    return issueType || "-";
}

// GsnsorInstallationDirection enum (device firmware, config_struct.h) - index is the raw
// cal_direction value (0-24). Index 0 is the "not yet determined" sentinel.
var CAL_DIRECTION_LABELS = [
    "Unknown", "Z up / X left", "Z up / X right", "Z up / Y left", "Z up / Y right",
    "Z down / X left", "Z down / X right", "Z down / Y left", "Z down / Y right",
    "X down / Z left", "X down / Z right", "X down / Y left", "X down / Y right",
    "X up / Z left", "X up / Z right", "X up / Y left", "X up / Y right",
    "Y down / Z left", "Y down / Z right", "Y down / X left", "Y down / X right",
    "Y up / Z left", "Y up / Z right", "Y up / X left", "Y up / X right",
];

function formatCalState(state) {
    if (state === 0 || state === undefined || state === null) return "Uncalibrated";
    if (state === 1) return "Calibrating";
    if (state === 2) return "Calibrated";
    if (state === 3) return "Failed";
    return String(state);
}

function formatCalDirection(direction) {
    if (direction === undefined || direction === null) return "-";
    if (direction >= 0 && direction < CAL_DIRECTION_LABELS.length) return CAL_DIRECTION_LABELS[direction];
    return String(direction);
}

function formatCalBangle(radians) {
    if (radians === undefined || radians === null) return "-";
    return (radians * 180 / Math.PI).toFixed(1) + "°";
}

function formatCalStartTime(epochSeconds) {
    if (!epochSeconds) return "-";
    var date = new Date(epochSeconds * 1000);
    if (isNaN(date.getTime())) return String(epochSeconds);
    return date.toLocaleString();
}

function formatHealthIssueKeys(keys) {
    if (!keys || !keys.length) return "-";
    return keys.map(formatHealthIssueLabel).join(", ");
}

function formatHealthTime(value) {
    if (!value) return "-";
    var date = new Date(value);
    if (isNaN(date.getTime())) return String(value);
    return date.toLocaleString();
}

function DeviceHealthSummary() {
    const record = useRecordContext();
    if (!record) return null;
    var issues = record.health_issues || [];
    return (
        <TableContainer component={Paper} style={{ marginBottom: "16px" }}>
            <Table sx={{ minWidth: 650 }} aria-label="device health table">
                <TableHead>
                    <TableRow>
                        <TableCell>Health</TableCell>
                        <TableCell>Issues</TableCell>
                        <TableCell>Updated</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>{formatHealthStatus(record.health_status)}</TableCell>
                        <TableCell>
                            {issues.length === 0 ? "-" : issues.map(function(issue) {
                                return issue.message || formatHealthIssueLabel(issue.issue_type);
                            }).join("; ")}
                        </TableCell>
                        <TableCell>{formatHealthTime(record.health_updated_at)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}

function formatCalDebugField(value) {
    if (value === undefined || value === null || value === "") return "-";
    return String(value);
}

function formatCalLastBackupTime(value) {
    // device reports -1 for "never uploaded" (LastBackupTime in DumpGsensorState()).
    if (value === undefined || value === null || value === "") return "-";
    var seconds = Number(value);
    if (isNaN(seconds) || seconds <= 0) return "-";
    return formatCalStartTime(seconds);
}

function DeviceCalibrationSummary() {
    const record = useRecordContext();
    if (!record) return null;
    var debug = record.gsensor_debug || {};
    return (
        <TableContainer component={Paper} style={{ marginBottom: "16px" }}>
            <Table sx={{ minWidth: 650 }} aria-label="device calibration table">
                <TableHead>
                    <TableRow>
                        <TableCell>Calibration</TableCell>
                        <TableCell>Direction</TableCell>
                        <TableCell>Tilt (roll / pitch / yaw)</TableCell>
                        <TableCell>Started</TableCell>
                        <TableCell>Step</TableCell>
                        <TableCell>Study Times</TableCell>
                        <TableCell>Install Mode</TableCell>
                        <TableCell>Last Backup</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>{formatCalState(record.cal_state)}</TableCell>
                        <TableCell>{formatCalDirection(record.cal_direction)}</TableCell>
                        <TableCell>
                            {formatCalBangle(record.cal_banglex)} / {formatCalBangle(record.cal_bangley)} / {formatCalBangle(record.cal_banglez)}
                        </TableCell>
                        <TableCell>{formatCalStartTime(record.cal_start_ts)}</TableCell>
                        <TableCell>{formatCalDebugField(debug.cal_auto_step)}</TableCell>
                        <TableCell>{formatCalDebugField(debug.cal_study_times)}</TableCell>
                        <TableCell>{formatCalDebugField(debug.cal_install_mode)}</TableCell>
                        <TableCell>{formatCalLastBackupTime(debug.cal_last_backup_ts)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}

function DeviceCalibrationBackupTab() {
    const record = useRecordContext();
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [backups, setBackups] = React.useState([]);
    const [pushing, setPushing] = React.useState(false);
    const [downloadingIndex, setDownloadingIndex] = React.useState(null);

    const fetchBackups = React.useCallback(function() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            setError("No token found");
            return;
        }
        setLoading(true);
        setError(null);
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/cal_backup", {
            headers: {
                "x-access-token": token
            }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.error) {
                var message = data && data.error ? data.error : "Invalid response";
                setError(message);
                return;
            }
            setBackups(data.result || []);
        }).catch(function(err) {
            var msg = err && err.message ? err.message : String(err);
            setError(msg);
            notify("Get calibration backups failed: " + msg, { type: "error" });
        }).finally(function() {
            setLoading(false);
        });
    }, [record, notify]);

    React.useEffect(function() {
        fetchBackups();
    }, [fetchBackups]);

    function handleRestore(index) {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        if (!window.confirm("Push calibration backup #" + index + " back to device " + record.device_id + "? "
            + "The device will download and apply it immediately, no driving required.")) {
            return;
        }

        setPushing(true);
        var post_data = {};
        post_data.device_id = record.device_id;
        post_data.source_device_id = record.device_id;
        post_data.index = index;
        axios.post(deviceControlApiUrl + 'push_cal_backup', post_data, {
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        }).then(function(response) {
            notify("Calibration backup #" + index + " pushed to " + record.device_id, { type: 'success' });
        }).catch(function(error) {
            notify("Push calibration backup failed: " + error, { type: 'error' });
        }).finally(function() {
            setPushing(false);
        });
    }

    // Same axios-blob + temporary-<a>/revokeObjectURL pattern as the Configuration tab's
    // backup download (GSENSOR_CALIBRATION.md section 34/35-style precedent) - the download
    // route requires an x-access-token header, so a plain <a href> can't carry auth.
    function handleDownload(backup) {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        setDownloadingIndex(backup.index);
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id)
                + "/cal_backup/" + backup.index + "/download", {
            headers: { "x-access-token": token },
            responseType: 'blob',
        }).then(function(response) {
            var blob = new Blob([response.data], { type: "application/octet-stream" });
            var url = URL.createObjectURL(blob);
            var link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", record.device_id + "_GsensorBaseVal_" + (backup.date_key || backup.index) + ".dat");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }).catch(function(error) {
            notify("Download failed: " + error, { type: 'error' });
        }).finally(function() {
            setDownloadingIndex(null);
        });
    }

    if (!record) return null;

    return (
        <TableContainer component={Paper}>
            {loading && <div style={{ padding: "12px" }}>Loading...</div>}
            {!loading && error && <div style={{ color: "#b00020", padding: "12px" }}>{error}</div>}
            {!loading && !error && backups.length === 0 && <div style={{ padding: "12px" }}>No calibration backups yet</div>}
            {!loading && !error && backups.length > 0 && (
                <Table sx={{ minWidth: 650 }} aria-label="calibration backup table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Timestamp</TableCell>
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {backups.map(function(backup) {
                            return (
                                <TableRow key={backup.index}>
                                    <TableCell>{backup.date_key || ("Backup #" + (backup.index + 1))}</TableCell>
                                    <TableCell>{formatCalStartTime(backup.device_ts)}</TableCell>
                                    <TableCell>
                                        <Button variant="contained" size="small" disabled={pushing}
                                            onClick={function() { handleRestore(backup.index); }}
                                            style={{ marginRight: "8px" }}>
                                            Restore to this device
                                        </Button>
                                        <Button variant="outlined" size="small" disabled={downloadingIndex === backup.index}
                                            onClick={function() { handleDownload(backup); }}>
                                            {downloadingIndex === backup.index ? "Downloading..." : "Download"}
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            )}
        </TableContainer>
    );
}

function formatGsensorEventType(eventType) {
    if (eventType === "CALIBRATION_SUCCESS") return "Success";
    if (eventType === "CALIBRATION_FAILED") return "Failed";
    if (eventType === "CALIBRATION_LOST") return "Lost";
    if (eventType === "CALIBRATION_RESET") return "Reset";
    if (eventType === "CALIBRATION_RESTORE_REQUESTED") return "Restore Requested";
    if (eventType === "CALIBRATION_RECONCILED") return "Reconciled at Boot";
    if (eventType === "HARD_ACCELERATION") return "Hard Acceleration";
    if (eventType === "HARD_DECELERATION") return "Hard Brake";
    if (eventType === "SHARP_TURN") return "Sharp Turn";
    if (eventType === "ROLLOVER") return "Rollover";
    if (eventType === "CRASH") return "Crash";
    return eventType || "-";
}

function formatGsensorDirectionChange(detail) {
    if (!detail) return "-";
    return formatCalDirection(detail.old_direction) + " -> " + formatCalDirection(detail.new_direction);
}

/* Live accelerometer/GPS/tilt reading at the moment an alarm fired - only present on
   hard_acceleration/hard_deceleration/sharp_turn/rollover events (GSENSOR_CALIBRATION.md
   section 27). accx/y/z are in g's; roll/pitch are radians (converted via formatCalBangle,
   same as the static tilt fields) since they come from the same AccVectorToRollPitchAngle()
   computation, just evaluated live instead of once at calibration time. */
// GsensorData_t.Roll/Pitch (DrivingPostureStudy.cpp:2100-2113) are already converted to degrees
// in firmware (Degrees()/RAD_TO_DEG) - unlike DrivingPostureConfig_t.Banglex/Bangley, which stay
// in radians. Do NOT run these through formatCalBangle() (a second radians->degrees conversion)
// - see GSENSOR_CALIBRATION.md section 31, found via real device data showing e.g. 1117.8deg for
// what was actually a 19.5deg tilt (57.3x too large - the telltale sign of a double conversion).
function formatDegrees(value) {
    if (value === undefined || value === null) return "-";
    return value.toFixed(1) + "°";
}

function formatGsensorLiveReading(detail, eventType) {
    if (!detail || detail.accx === undefined) return "-";
    var acc = detail.accx.toFixed(2) + "/" + detail.accy.toFixed(2) + "/" + detail.accz.toFixed(2) + "g";
    var speed = (detail.gpsspeed !== undefined ? detail.gpsspeed.toFixed(0) : "-") + "km/h";
    var tilt = formatDegrees(detail.roll) + "/" + formatDegrees(detail.pitch);
    var reading = "acc " + acc + " @ " + speed + ", tilt " + tilt;
    // peak: re-scanned from the device's detection queue, not the instantaneous sample above -
    // see GSENSOR_CALIBRATION.md sections 30/33. Unit depends on event type: rollover's peak is
    // a tilt angle in degrees (same Roll/Pitch source, formatDegrees - not formatCalBangle); the
    // other four (accel/decel/turn/crash) are a g-force magnitude.
    if (detail.peak !== undefined && detail.peak !== null) {
        if (eventType === "ROLLOVER") {
            reading += ", peak tilt " + formatDegrees(detail.peak);
        } else {
            reading += ", peak " + detail.peak.toFixed(2) + "g";
        }
    }
    return reading;
}

/* Single "Detail" column content, tailored to what's actually in event.detail rather than a
   fixed set of columns most event types leave blank - dispatches on shape (does detail.accx
   exist?) rather than a long list of event_type string checks, so it keeps working for any
   future event type that reuses one of the two existing schemas. Returns an array of lines,
   rendered stacked in the cell. */
function formatGsensorEventDetail(event) {
    var detail = event.detail || {};
    var lines = [];
    if (detail.accx !== undefined) {
        // hard_acceleration/hard_deceleration/sharp_turn/rollover (GSENSOR_CALIBRATION.md 27)
        lines.push("Direction: " + formatCalDirection(detail.new_direction));
        lines.push(formatGsensorLiveReading(detail, event.event_type));
        return lines;
    }
    // calibration_success/failed/lost/reset/reconciled/restore_requested (sections 13/22/24/25)
    lines.push("Direction: " + formatGsensorDirectionChange(detail));
    lines.push("Tilt: " + formatCalBangle(detail.banglex) + " / " + formatCalBangle(detail.bangley) + " / " + formatCalBangle(detail.banglez));
    if (detail.study_times !== undefined && detail.study_times !== null) {
        lines.push("Study Times: " + formatCalDebugField(detail.study_times));
    }
    if (detail.studied_direction !== undefined && detail.studied_direction !== null) {
        lines.push("Studied Direction: " + formatCalDirection(detail.studied_direction));
        lines.push("Studied Tilt: " + formatCalBangle(detail.studied_banglex) + " / " + formatCalBangle(detail.studied_bangley) + " / " + formatCalBangle(detail.studied_banglez));
    }
    return lines;
}

/* Plain chronological log of calibration_success/calibration_failed/calibration_lost events -
   deliberately separate from DeviceHealthEventsTab (open/resolved health issues). See
   GSENSOR_CALIBRATION.md section 20. */
var GSENSOR_EVENTS_PER_PAGE = 20;

// RFC 4180-ish escaping: quote any field containing a comma, quote, or newline, doubling
// embedded quotes. Detail lines (formatGsensorEventDetail()) are joined with " | " rather than
// kept as separate CSV lines, so each event stays exactly one CSV row.
function csvEscape(value) {
    var str = value === undefined || value === null ? "" : String(value);
    if (/[",\n]/.test(str)) {
        str = '"' + str.replace(/"/g, '""') + '"';
    }
    return str;
}

function triggerCsvDownload(filename, csvContent) {
    var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

function DeviceGsensorEventsTab() {
    const record = useRecordContext();
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [events, setEvents] = React.useState([]);
    const [clearing, setClearing] = React.useState(false);
    const [downloading, setDownloading] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const [total, setTotal] = React.useState(0);
    const [pageInput, setPageInput] = React.useState("1");

    const fetchEvents = React.useCallback(function() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            setError("No token found");
            return;
        }
        setLoading(true);
        setError(null);
        var range_min = page * GSENSOR_EVENTS_PER_PAGE;
        var range_max = range_min + GSENSOR_EVENTS_PER_PAGE - 1;
        var params = "range=" + encodeURIComponent(JSON.stringify([range_min, range_max]));
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/gsensor_events?" + params, {
            headers: {
                "x-access-token": token
            }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.error) {
                var message = data && data.error ? data.error : "Invalid response";
                setError(message);
                return;
            }
            setEvents(data.result || []);
            setTotal(data.count || 0);
        }).catch(function(err) {
            var msg = err && err.message ? err.message : String(err);
            setError(msg);
            notify("Get g-sensor events failed: " + msg, { type: "error" });
        }).finally(function() {
            setLoading(false);
        });
    }, [record, notify, page]);

    React.useEffect(function() {
        fetchEvents();
    }, [fetchEvents]);

    // Device (re)selected, or the list was just cleared - always land back on the first page
    // rather than potentially pointing past the end of a now-shorter (or different) list.
    React.useEffect(function() {
        setPage(0);
    }, [record && record.device_id]);

    var pageCount = Math.max(1, Math.ceil(total / GSENSOR_EVENTS_PER_PAGE));

    // Keep the free-typed page-number box in sync whenever page changes via Previous/Next (or
    // an external reset) - only overwritten here, never while the user is actively typing.
    React.useEffect(function() {
        setPageInput(String(page + 1));
    }, [page]);

    function commitPageInput() {
        var parsed = parseInt(pageInput, 10);
        if (isNaN(parsed)) {
            setPageInput(String(page + 1));
            return;
        }
        var clamped = Math.min(Math.max(parsed, 1), pageCount);
        setPageInput(String(clamped));
        if (clamped - 1 !== page) {
            setPage(clamped - 1);
        }
    }

    function handleClear() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        if (!window.confirm("Clear all g-sensor events for device " + record.device_id + "? This cannot be undone.")) {
            return;
        }
        setClearing(true);
        var post_data = {};
        post_data.device_id = record.device_id;
        axios.post(deviceControlApiUrl + 'clear_gsensor_events', post_data, {
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': `${token}`
            }
        }).then(function(response) {
            notify("G-sensor events cleared for " + record.device_id, { type: 'success' });
            if (page === 0) {
                fetchEvents();
            } else {
                setPage(0); // triggers a refetch via the fetchEvents effect above
            }
        }).catch(function(error) {
            notify("Clear g-sensor events failed: " + error, { type: 'error' });
        }).finally(function() {
            setClearing(false);
        });
    }

    // Downloads every event for this device, not just the current page - a separate fetch
    // with range=[0, total-1] rather than reusing the paginated `events` state (which only ever
    // holds one page's worth of rows).
    function handleDownloadCsv() {
        if (!record || !record.device_id || total <= 0) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        setDownloading(true);
        var params = "range=" + encodeURIComponent(JSON.stringify([0, total - 1]));
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/gsensor_events?" + params, {
            headers: {
                "x-access-token": token
            }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.error) {
                var message = data && data.error ? data.error : "Invalid response";
                notify("Download CSV failed: " + message, { type: "error" });
                return;
            }
            var allEvents = data.result || [];
            var rows = [["Event", "Time", "Message", "Detail"]];
            allEvents.forEach(function(event) {
                rows.push([
                    formatGsensorEventType(event.event_type),
                    formatHealthTime(event.created_at),
                    event.message || "",
                    formatGsensorEventDetail(event).join(" | "),
                ]);
            });
            var csvContent = rows.map(function(row) {
                return row.map(csvEscape).join(",");
            }).join("\r\n");
            triggerCsvDownload("gsensor_events_" + record.device_id + ".csv", csvContent);
        }).catch(function(err) {
            var msg = err && err.message ? err.message : String(err);
            notify("Download CSV failed: " + msg, { type: "error" });
        }).finally(function() {
            setDownloading(false);
        });
    }

    if (!record) return null;

    return (
        <div>
            <Button variant="contained" size="small" color="error" disabled={clearing || total === 0}
                onClick={handleClear} style={{ marginBottom: "12px", marginRight: "8px" }}>
                Clear All Events
            </Button>
            <Button variant="outlined" size="small" disabled={downloading || total === 0}
                onClick={handleDownloadCsv} style={{ marginBottom: "12px" }}>
                {downloading ? "Downloading..." : "Download CSV"}
            </Button>
            <TableContainer component={Paper}>
                {loading && <div style={{ padding: "12px" }}>Loading...</div>}
                {!loading && error && <div style={{ color: "#b00020", padding: "12px" }}>{error}</div>}
                {!loading && !error && events.length === 0 && <div style={{ padding: "12px" }}>No g-sensor events</div>}
                {!loading && !error && events.length > 0 && (
                    <Table sx={{ minWidth: 650 }} aria-label="gsensor events table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Event</TableCell>
                                <TableCell>Time</TableCell>
                                <TableCell>Message</TableCell>
                                <TableCell>Detail</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {events.map(function(event) {
                                return (
                                    <TableRow key={event._id}>
                                        <TableCell>{formatGsensorEventType(event.event_type)}</TableCell>
                                        <TableCell>{formatHealthTime(event.created_at)}</TableCell>
                                        <TableCell>{event.message}</TableCell>
                                        <TableCell>
                                            {formatGsensorEventDetail(event).map(function(line, idx) {
                                                return <div key={idx}>{line}</div>;
                                            })}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                )}
            </TableContainer>
            {!loading && !error && total > 0 && (
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "12px" }}>
                    <Button variant="outlined" size="small" disabled={page <= 0}
                        onClick={function() { setPage(page - 1); }}>
                        Previous
                    </Button>
                    <span>Page</span>
                    <MuiTextField
                        type="number"
                        size="small"
                        variant="outlined"
                        value={pageInput}
                        inputProps={{ min: 1, max: pageCount, style: { width: "40px", padding: "4px 8px", textAlign: "center" } }}
                        onChange={function(e) { setPageInput(e.target.value); }}
                        onBlur={commitPageInput}
                        onKeyDown={function(e) { if (e.key === "Enter") { commitPageInput(); } }}
                    />
                    <span>of {pageCount} ({total} events)</span>
                    <Button variant="outlined" size="small" disabled={page >= pageCount - 1}
                        onClick={function() { setPage(page + 1); }}>
                        Next
                    </Button>
                </div>
            )}
        </div>
    );
}

/* Configuration monitoring - device detail "Configuration" tab (ET12_CONFIGURATION_MONITORING_
   SPEC.md section 24, device SDK repo root). Shows the persisted summary (GET .../
   config_comparison, fast - just reads Device fields server-side) plus an on-demand
   "View Differences" fetch (GET .../config_comparison/details) that recomputes live from the
   template + device archives server-side rather than caching stale detail - see
   ET12_CONFIGURATION_MONITORING_IMPLEMENTATION.md section 6 for why. */
function formatConfigState(state) {
    if (state === 'mismatch') return 'MISMATCH';
    if (state === 'normal') return 'NORMAL';
    return 'UNKNOWN';
}

function formatConfigSubstate(substate) {
    if (!substate) return '-';
    return substate.replace(/_/g, ' ');
}

function DeviceConfigurationTab() {
    const record = useRecordContext();
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [summary, setSummary] = React.useState(null);
    const [templates, setTemplates] = React.useState([]);
    const [selectedTemplateId, setSelectedTemplateId] = React.useState('');
    const [assigning, setAssigning] = React.useState(false);
    const [fetchingConfig, setFetchingConfig] = React.useState(false);
    const [details, setDetails] = React.useState(null);
    const [detailsLoading, setDetailsLoading] = React.useState(false);
    const [showDetails, setShowDetails] = React.useState(false);
    const [backups, setBackups] = React.useState([]);
    const [backupsLoading, setBackupsLoading] = React.useState(false);
    const [downloadingKey, setDownloadingKey] = React.useState(null);
    const [parameters, setParameters] = React.useState([]);
    const [parametersLoading, setParametersLoading] = React.useState(false);
    const [parametersError, setParametersError] = React.useState(null);
    const [parametersAvailable, setParametersAvailable] = React.useState(false);
    const [parameterQuery, setParameterQuery] = React.useState('');
    const [pendingParamEdits, setPendingParamEdits] = React.useState({});
    const [editingParamName, setEditingParamName] = React.useState(null);
    const [editingParamValue, setEditingParamValue] = React.useState('');
    const [committingParams, setCommittingParams] = React.useState(false);

    const fetchBackups = React.useCallback(function() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) return;
        setBackupsLoading(true);
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/config_backups", {
            headers: { "x-access-token": token }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (data && !data.error) {
                setBackups(data.result || []);
            }
        }).catch(function() { /* non-fatal - the summary section above already reports the last backup time */ })
        .finally(function() {
            setBackupsLoading(false);
        });
    }, [record]);

    React.useEffect(function() {
        fetchBackups();
    }, [fetchBackups]);

    const fetchParameters = React.useCallback(function() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) return;
        setParametersLoading(true);
        setParametersError(null);
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/config_parameters", {
            headers: { "x-access-token": token }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.error) {
                setParametersError(data && data.error ? data.error : "Invalid response");
                return;
            }
            var result = data.result || {};
            setParameters(result.parameters || []);
            setParametersAvailable(!!result.backup_available);
            if (result.warning) {
                notify("Parameters loaded with warnings: " + result.warning, { type: "warning" });
            }
        }).catch(function(err) {
            var msg = err && err.message ? err.message : String(err);
            setParametersError(msg);
        }).finally(function() {
            setParametersLoading(false);
        });
    }, [record, notify]);

    React.useEffect(function() {
        fetchParameters();
    }, [fetchParameters]);

    var filteredParameters = React.useMemo(function() {
        if (!parameterQuery) return parameters;
        var q = parameterQuery.toLowerCase();
        return parameters.filter(function(p) {
            return p.name.toLowerCase().indexOf(q) !== -1 || String(p.value).toLowerCase().indexOf(q) !== -1;
        });
    }, [parameters, parameterQuery]);

    function startEditParam(p) {
        setEditingParamName(p.name);
        setEditingParamValue(pendingParamEdits[p.name] !== undefined ? pendingParamEdits[p.name] : String(p.value));
    }

    function cancelEditParam() {
        setEditingParamName(null);
        setEditingParamValue('');
    }

    function queueEditParam() {
        setPendingParamEdits(function(prev) {
            var next = Object.assign({}, prev);
            next[editingParamName] = editingParamValue;
            return next;
        });
        setEditingParamName(null);
        setEditingParamValue('');
    }

    function removePendingParamEdit(name) {
        setPendingParamEdits(function(prev) {
            var next = Object.assign({}, prev);
            delete next[name];
            return next;
        });
    }

    function cancelAllPendingParamEdits() {
        setPendingParamEdits({});
    }

    function commitPendingParamEdits() {
        if (!record || !record.device_id) return;
        var names = Object.keys(pendingParamEdits);
        if (names.length === 0) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        setCommittingParams(true);
        axios.post(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/param_set",
            { params: pendingParamEdits },
            { headers: { "Content-Type": "application/json", "x-access-token": token } }
        ).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.error) {
                notify("Commit failed: " + (data && data.error ? data.error : "Invalid response"), { type: "error" });
                return;
            }
            setPendingParamEdits({});
            notify(names.length + " parameter(s) queued to the device - will apply once it checks in", { type: "success" });
        }).catch(function(err) {
            var msg = (err && err.response && err.response.data && err.response.data.error)
                || (err && err.message) || String(err);
            notify("Commit failed: " + msg, { type: "error" });
        }).finally(function() {
            setCommittingParams(false);
        });
    }

    function handleDownloadBackup(dateKey) {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        setDownloadingKey(dateKey);
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id)
                + "/config_backups/" + encodeURIComponent(dateKey) + "/download", {
            headers: { "x-access-token": token },
            responseType: 'blob',
        }).then(function(response) {
            var blob = new Blob([response.data], { type: "application/gzip" });
            var url = URL.createObjectURL(blob);
            var link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", record.device_id + "_" + dateKey + ".tar.gz");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }).catch(function(error) {
            notify("Download failed: " + error, { type: 'error' });
        }).finally(function() {
            setDownloadingKey(null);
        });
    }

    const fetchSummary = React.useCallback(function() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            setError("No token found");
            return;
        }
        setLoading(true);
        setError(null);
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/config_comparison", {
            headers: { "x-access-token": token }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.error) {
                setError(data && data.error ? data.error : "Invalid response");
                return;
            }
            setSummary(data.result);
            setSelectedTemplateId(data.result && data.result.config_template ? data.result.config_template._id : '');
        }).catch(function(err) {
            setError(err && err.message ? err.message : String(err));
        }).finally(function() {
            setLoading(false);
        });
    }, [record]);

    React.useEffect(function() {
        fetchSummary();
    }, [fetchSummary]);

    React.useEffect(function() {
        const token = inMemoryJWT.getToken();
        if (!token) {
            return;
        }
        // Template list is admin-only (routes/api.js's GET /config_templates) - a non-admin
        // viewer simply won't see the "Change Template" dropdown populate, everything else
        // on this tab still works for them.
        axios.get(apiBaseUrl + "/config_templates?range=" + encodeURIComponent(JSON.stringify([0, 199])), {
            headers: { "x-access-token": token }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (data && !data.error) {
                setTemplates(data.result || []);
            }
        }).catch(function() { /* see comment above */ });
    }, []);

    function handleAssign() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        setAssigning(true);
        var post_data = { device_id: record.device_id, template_id: selectedTemplateId || null };
        axios.post(deviceControlApiUrl + 'assign_config_template', post_data, {
            headers: { 'Content-Type': 'application/json', 'x-access-token': `${token}` }
        }).then(function() {
            notify((selectedTemplateId ? "Template assigned" : "Template unassigned") + " for " + record.device_id, { type: 'success' });
            setShowDetails(false);
            setDetails(null);
            fetchSummary();
        }).catch(function(error) {
            notify("Assign template failed: " + error, { type: 'error' });
        }).finally(function() {
            setAssigning(false);
        });
    }

    function handleFetchConfig() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        setFetchingConfig(true);
        axios.post(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/fetch_config", {}, {
            headers: { "Content-Type": "application/json", "x-access-token": token }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.error) {
                notify("Fetch config failed: " + (data && data.error ? data.error : "Invalid response"), { type: "error" });
                return;
            }
            notify("Fetch requested - device will upload a fresh backup shortly", { type: "success" });
        }).catch(function(err) {
            var msg = (err && err.response && err.response.data && err.response.data.error)
                || (err && err.message) || String(err);
            notify("Fetch config failed: " + msg, { type: "error" });
        }).finally(function() {
            setFetchingConfig(false);
        });
    }

    function handleViewDetails() {
        if (showDetails) {
            setShowDetails(false);
            return;
        }
        setShowDetails(true);
        if (details) {
            return; // already fetched once this visit - don't refetch on every toggle
        }
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        setDetailsLoading(true);
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/config_comparison/details", {
            headers: { "x-access-token": token }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.error) {
                notify("Get differences failed: " + (data && data.error ? data.error : "unknown error"), { type: "error" });
                return;
            }
            setDetails(data.result);
        }).catch(function(err) {
            notify("Get differences failed: " + (err && err.message ? err.message : String(err)), { type: "error" });
        }).finally(function() {
            setDetailsLoading(false);
        });
    }

    if (!record) return null;

    return (
        <div>
            {loading && <div style={{ padding: "12px" }}>Loading...</div>}
            {!loading && error && <div style={{ color: "#b00020", padding: "12px" }}>{error}</div>}
            {!loading && !error && summary && (
                <div style={{ marginBottom: "16px" }}>
                    <Button variant="outlined" size="small" disabled={fetchingConfig} onClick={handleFetchConfig} style={{ marginBottom: "12px" }}>
                        {fetchingConfig ? "Requesting..." : "Fetch current config"}
                    </Button>
                    <div><b>Assigned Template:</b> {summary.config_template ? summary.config_template.name : "None"}</div>
                    {templates.length > 0 && (
                        <div style={{ marginTop: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
                            <MuiTextField select size="small" label="Change Template" value={selectedTemplateId}
                                onChange={function(e) { setSelectedTemplateId(e.target.value); }}
                                style={{ minWidth: "240px" }}>
                                <MenuItem value="">None (stop monitoring)</MenuItem>
                                {templates.map(function(t) {
                                    return <MenuItem key={t._id} value={t._id}>{t.name}</MenuItem>;
                                })}
                            </MuiTextField>
                            <Button variant="contained" size="small" disabled={assigning} onClick={handleAssign}>
                                {assigning ? "Saving..." : "Save"}
                            </Button>
                        </div>
                    )}

                    {summary.config_template ? (
                        <div style={{ marginTop: "16px" }}>
                            <div><b>Configuration State:</b> {formatConfigState(summary.config_state)}</div>
                            <div><b>Substate:</b> {formatConfigSubstate(summary.config_substate)}</div>
                            <div><b>Last Backup:</b> {formatHealthTime(summary.config_last_backup_at)}</div>
                            <div><b>Last Compared:</b> {formatHealthTime(summary.config_last_checked_at)}</div>
                            <div><b>Value Mismatches:</b> {summary.config_value_mismatch_count || 0}</div>
                            <div><b>Extra Parameters:</b> {summary.config_extra_count || 0}</div>
                            <div><b>Missing Parameters:</b> {summary.config_missing_count || 0}</div>
                            <Button variant="outlined" size="small" style={{ marginTop: "12px" }} onClick={handleViewDetails}>
                                {showDetails ? "Hide Differences" : "View Differences"}
                            </Button>
                        </div>
                    ) : (
                        <div style={{ marginTop: "16px" }}>
                            <div>Configuration comparison: Not monitored</div>
                            <div><b>Last Backup:</b> {formatHealthTime(summary.config_last_backup_at)}</div>
                        </div>
                    )}
                </div>
            )}

            {/* Available backups (spec section 5.1: up to the 3 most recent distinct
                calendar dates are kept on the server per device) - listed regardless of
                whether a template is assigned, since backup storage and comparison are
                separate concerns (spec section 5.2). */}
            <div style={{ marginBottom: "16px" }}>
                <div style={{ marginBottom: "8px" }}><b>Available Configuration Backups</b></div>
                {backupsLoading && <div style={{ padding: "12px" }}>Loading...</div>}
                {!backupsLoading && backups.length === 0 && <div style={{ padding: "12px" }}>No backups yet</div>}
                {!backupsLoading && backups.length > 0 && (
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 400 }} aria-label="config backups table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {backups.map(function(backup) {
                                    return (
                                        <TableRow key={backup.date_key}>
                                            <TableCell>{backup.date_key}</TableCell>
                                            <TableCell>
                                                <Button variant="outlined" size="small"
                                                    disabled={downloadingKey === backup.date_key}
                                                    onClick={function() { handleDownloadBackup(backup.date_key); }}>
                                                    {downloadingKey === backup.date_key ? "Downloading..." : "Download"}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </div>

            {showDetails && detailsLoading && <div style={{ padding: "12px" }}>Loading differences...</div>}
            {showDetails && !detailsLoading && details && (
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="config differences table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Type</TableCell>
                                <TableCell>Path</TableCell>
                                <TableCell>Expected (Template)</TableCell>
                                <TableCell>Device</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(details.mismatch || []).map(function(row, idx) {
                                return (
                                    <TableRow key={"mismatch-" + idx}>
                                        <TableCell style={{ color: "#b00020" }}>Value Mismatch</TableCell>
                                        <TableCell>{row.path}</TableCell>
                                        <TableCell>{String(row.template_value)}</TableCell>
                                        <TableCell>{String(row.device_value)}</TableCell>
                                    </TableRow>
                                );
                            })}
                            {(details.extra || []).map(function(row, idx) {
                                return (
                                    <TableRow key={"extra-" + idx}>
                                        <TableCell>Extra on Device</TableCell>
                                        <TableCell>{row.path}</TableCell>
                                        <TableCell>-</TableCell>
                                        <TableCell>{String(row.device_value)}</TableCell>
                                    </TableRow>
                                );
                            })}
                            {(details.missing || []).map(function(row, idx) {
                                return (
                                    <TableRow key={"missing-" + idx}>
                                        <TableCell>Missing on Device</TableCell>
                                        <TableCell>{row.path}</TableCell>
                                        <TableCell>{String(row.template_value)}</TableCell>
                                        <TableCell>-</TableCell>
                                    </TableRow>
                                );
                            })}
                            {(!details.mismatch || details.mismatch.length === 0)
                                && (!details.extra || details.extra.length === 0)
                                && (!details.missing || details.missing.length === 0) && (
                                <TableRow>
                                    <TableCell colSpan={4}>No differences</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            <div style={{ marginTop: "24px" }}>
                <h3 style={{ marginBottom: "8px" }}>Device parameters</h3>
                {parametersLoading && <div>Loading parameters...</div>}
                {!parametersLoading && parametersError && <div style={{ color: "#b00020" }}>{parametersError}</div>}
                {!parametersLoading && !parametersError && !parametersAvailable && (
                    <div>No backup available to browse parameters.</div>
                )}
                {!parametersLoading && !parametersError && parametersAvailable && (
                    <div>
                        <div style={{ position: "relative", maxWidth: "480px" }}>
                            <MuiTextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                placeholder="Search parameters..."
                                value={parameterQuery}
                                onChange={function(e) { setParameterQuery(e.target.value); }}
                            />
                            {parameterQuery && (
                                <IconButton size="small" aria-label="Clear search"
                                    style={{ position: "absolute", right: "4px", top: "4px" }}
                                    onClick={function() { setParameterQuery(''); }}>
                                    &times;
                                </IconButton>
                            )}
                        </div>
                        <div style={{ marginTop: "8px", maxHeight: "480px", overflowY: "auto" }}>
                            {filteredParameters.length === 0 && (
                                <div style={{ padding: "8px", color: "#666" }}>No matching parameters</div>
                            )}
                            {filteredParameters.map(function(p) {
                                var isEditing = editingParamName === p.name;
                                var hasPending = Object.prototype.hasOwnProperty.call(pendingParamEdits, p.name);
                                return (
                                    <div key={p.name} style={{ padding: "3px 0", borderBottom: "1px solid #f0f0f0", fontFamily: "monospace", fontSize: "13px", display: "flex", alignItems: "center", gap: "6px" }}>
                                        <span style={{ flexGrow: 1 }}>
                                            {p.name}{" "}
                                            {isEditing ? (
                                                <MuiTextField
                                                    size="small"
                                                    variant="standard"
                                                    autoFocus
                                                    value={editingParamValue}
                                                    onChange={function(e) { setEditingParamValue(e.target.value); }}
                                                    onKeyDown={function(e) { if (e.key === 'Enter') queueEditParam(); if (e.key === 'Escape') cancelEditParam(); }}
                                                />
                                            ) : (
                                                <b style={hasPending ? { textDecoration: "line-through", color: "#999" } : undefined}>
                                                    {String(p.value)}
                                                </b>
                                            )}
                                            {!isEditing && hasPending && (
                                                <b style={{ color: "#b00020", marginLeft: "6px" }}>{String(pendingParamEdits[p.name])}</b>
                                            )}
                                        </span>
                                        {isEditing ? (
                                            <React.Fragment>
                                                <Button size="small" variant="text" onClick={queueEditParam}>Queue</Button>
                                                <Button size="small" variant="text" onClick={cancelEditParam}>Cancel</Button>
                                            </React.Fragment>
                                        ) : (
                                            p.editable !== false && (
                                                <IconButton size="small" aria-label={"Edit " + p.name} onClick={function() { startEditParam(p); }}>
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                        <div style={{ marginTop: "4px", color: "#999", fontSize: "12px" }}>
                            {filteredParameters.length} of {parameters.length} parameters
                        </div>
                    </div>
                )}
            </div>

            {Object.keys(pendingParamEdits).length > 0 && (
                <div style={{
                    position: "fixed", top: "72px", right: "16px", zIndex: 1300,
                    background: "#fff", border: "1px solid #ddd", borderRadius: "4px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)", padding: "12px", minWidth: "220px",
                }}>
                    <div style={{ fontWeight: "bold", marginBottom: "6px" }}>Pending tasks</div>
                    {Object.keys(pendingParamEdits).map(function(name) {
                        return (
                            <div key={name} style={{ color: "#b00020", fontStyle: "italic", fontSize: "13px", display: "flex", alignItems: "center", gap: "4px" }}>
                                <span style={{ flexGrow: 1 }}>Edit {name}</span>
                                <IconButton size="small" aria-label={"Remove queued edit for " + name}
                                    onClick={function() { removePendingParamEdit(name); }}>
                                    &times;
                                </IconButton>
                            </div>
                        );
                    })}
                    <div style={{ marginTop: "8px", display: "flex", gap: "8px", alignItems: "center" }}>
                        <Button variant="contained" size="small" disabled={committingParams} onClick={commitPendingParamEdits}>
                            {committingParams ? "Committing..." : "Commit"}
                        </Button>
                        <Button variant="text" size="small" disabled={committingParams} onClick={cancelAllPendingParamEdits}>
                            Cancel
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
}

/* Per-device email notification settings - ET12_CONFIGURATION_MONITORING_SPEC.md section 18.
   Controls email only - events are always recorded regardless (spec section 19), there is no
   event enable/disable checkbox here on purpose. */
function DeviceNotificationConfigTab() {
    const record = useRecordContext();
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [masterEnabled, setMasterEnabled] = React.useState(false);
    const [emailRecipientsText, setEmailRecipientsText] = React.useState('');
    const [deviceOfflineEnabled, setDeviceOfflineEnabled] = React.useState(false);
    const [offlineThreshold, setOfflineThreshold] = React.useState(30);
    const [healthAlertEnabled, setHealthAlertEnabled] = React.useState(false);
    const [gsensorAlertEnabled, setGsensorAlertEnabled] = React.useState(false);
    const [configMismatchEnabled, setConfigMismatchEnabled] = React.useState(false);
    const [saving, setSaving] = React.useState(false);
    const [testing, setTesting] = React.useState(false);

    const fetchConfig = React.useCallback(function() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            setError("No token found");
            return;
        }
        setLoading(true);
        setError(null);
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/notification_config", {
            headers: { "x-access-token": token }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.error) {
                setError(data && data.error ? data.error : "Invalid response");
                return;
            }
            var cfg = data.result || {};
            setMasterEnabled(!!cfg.enabled);
            setEmailRecipientsText((cfg.email_recipients || []).join(", "));
            setDeviceOfflineEnabled(!!(cfg.device_offline && cfg.device_offline.email_enabled));
            setOfflineThreshold((cfg.device_offline && cfg.device_offline.offline_threshold_minutes) || 30);
            setHealthAlertEnabled(!!(cfg.health_alert && cfg.health_alert.email_enabled));
            setGsensorAlertEnabled(!!(cfg.gsensor_alert && cfg.gsensor_alert.email_enabled));
            setConfigMismatchEnabled(!!(cfg.configuration_mismatch && cfg.configuration_mismatch.email_enabled));
        }).catch(function(err) {
            setError(err && err.message ? err.message : String(err));
        }).finally(function() {
            setLoading(false);
        });
    }, [record]);

    React.useEffect(function() {
        fetchConfig();
    }, [fetchConfig]);

    function currentRecipients() {
        return emailRecipientsText.split(",").map(function(s) { return s.trim(); }).filter(function(s) { return s.length > 0; });
    }

    function handleSave() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        setSaving(true);
        var post_data = {
            device_id: record.device_id,
            enabled: masterEnabled,
            email_recipients: currentRecipients(),
            device_offline: { email_enabled: deviceOfflineEnabled, offline_threshold_minutes: parseInt(offlineThreshold, 10) || 30 },
            health_alert: { email_enabled: healthAlertEnabled },
            gsensor_alert: { email_enabled: gsensorAlertEnabled },
            configuration_mismatch: { email_enabled: configMismatchEnabled },
        };
        axios.post(deviceControlApiUrl + 'notification_config', post_data, {
            headers: { 'Content-Type': 'application/json', 'x-access-token': `${token}` }
        }).then(function() {
            notify("Notification configuration saved for " + record.device_id, { type: 'success' });
        }).catch(function(error) {
            notify("Save failed: " + error, { type: 'error' });
        }).finally(function() {
            setSaving(false);
        });
    }

    // Deliberately sends to whatever is currently typed in the recipients box, not
    // necessarily saved yet, and ignores the master/category switches entirely - see the
    // backend route's own comment (routes/api.js, POST /device/notification_config/test) for
    // why a "test" action should never be gated by the same settings it's meant to verify.
    function handleTestEmail() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        var recipients = currentRecipients();
        if (recipients.length === 0) {
            notify("Enter at least one email recipient first", { type: "warning" });
            return;
        }
        setTesting(true);
        axios.post(deviceControlApiUrl + 'notification_config/test',
            { device_id: record.device_id, email_recipients: recipients },
            { headers: { 'Content-Type': 'application/json', 'x-access-token': `${token}` } }
        ).then(function() {
            notify("Test email sent to " + recipients.join(", "), { type: 'success' });
        }).catch(function(error) {
            notify("Test email failed: " + error, { type: 'error' });
        }).finally(function() {
            setTesting(false);
        });
    }

    if (!record) return null;

    return (
        <div style={{ maxWidth: "480px" }}>
            {loading && <div style={{ padding: "12px" }}>Loading...</div>}
            {!loading && error && <div style={{ color: "#b00020", padding: "12px" }}>{error}</div>}
            {!loading && !error && (
                <div>
                    <FormControlLabel control={<Checkbox checked={masterEnabled}
                        onChange={function(e) { setMasterEnabled(e.target.checked); }} />}
                        label={<b>Enable Email Notifications</b>} />

                    <div style={{ marginTop: "12px", marginBottom: "16px" }}>
                        <MuiTextField label="Email recipients (comma-separated)" fullWidth size="small"
                            value={emailRecipientsText}
                            onChange={function(e) { setEmailRecipientsText(e.target.value); }} />
                        <Button variant="outlined" size="small" disabled={testing} onClick={handleTestEmail} style={{ marginTop: "8px" }}>
                            {testing ? "Sending..." : "Send Test Email"}
                        </Button>
                    </div>

                    {masterEnabled && (
                        <div>
                            <div style={{ marginBottom: "4px" }}><b>Email Notifications</b></div>
                            <div>
                                <FormControlLabel control={<Checkbox checked={deviceOfflineEnabled}
                                    onChange={function(e) { setDeviceOfflineEnabled(e.target.checked); }} />}
                                    label="Device offline" />
                            </div>
                            <div>
                                <FormControlLabel control={<Checkbox checked={healthAlertEnabled}
                                    onChange={function(e) { setHealthAlertEnabled(e.target.checked); }} />}
                                    label="Health alert" />
                            </div>
                            <div>
                                <FormControlLabel control={<Checkbox checked={gsensorAlertEnabled}
                                    onChange={function(e) { setGsensorAlertEnabled(e.target.checked); }} />}
                                    label="G-sensor alert" />
                            </div>
                            <div>
                                <FormControlLabel control={<Checkbox checked={configMismatchEnabled}
                                    onChange={function(e) { setConfigMismatchEnabled(e.target.checked); }} />}
                                    label="Configuration mismatch" />
                            </div>

                            <div style={{ marginTop: "16px" }}>
                                <MuiTextField label="Device offline after (minutes)" type="number" size="small"
                                    value={offlineThreshold}
                                    onChange={function(e) { setOfflineThreshold(e.target.value); }}
                                    style={{ width: "220px" }} />
                            </div>
                        </div>
                    )}

                    <Button variant="contained" size="small" disabled={saving} onClick={handleSave} style={{ marginTop: "16px" }}>
                        {saving ? "Saving..." : "Save"}
                    </Button>
                </div>
            )}
        </div>
    );
}

function buildHealthEventsCsv(events) {
    var header = ["Event Type", "Issue", "Status", "Created", "Resolved", "Message"];
    var rows = events.map(function(event) {
        return [
            event.event_type,
            formatHealthIssueLabel(event.issue_type),
            event.status,
            formatHealthTime(event.created_at),
            formatHealthTime(event.resolved_at),
            event.message || "-",
        ];
    });
    return [header].concat(rows).map(function(row) {
        return row.map(csvEscape).join(",");
    }).join("\r\n");
}

function DeviceHealthEventsTab() {
    const record = useRecordContext();
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [events, setEvents] = React.useState([]);
    const [deletingId, setDeletingId] = React.useState(null);
    const [clearing, setClearing] = React.useState(false);

    function fetchEvents() {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            setError("No token found");
            return;
        }
        setLoading(true);
        setError(null);
        var params = "device_id=" + encodeURIComponent(record.device_id)
            + "&sort=" + encodeURIComponent(JSON.stringify(["created_at", "DESC"]))
            + "&range=" + encodeURIComponent(JSON.stringify([0, 49]));
        axios.get(apiBaseUrl + "/device-events?" + params, {
            headers: {
                "x-access-token": token
            }
        }).then(function(response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.error) {
                var message = data && data.error ? data.error : "Invalid response";
                setError(message);
                return;
            }
            // g-sensor calibration events live on the GSensor tab's own log (DeviceGsensorEventsTab)
            // now, not here - see GSENSOR_CALIBRATION.md section 20.
            var allEvents = data.result || [];
            setEvents(allEvents.filter(function(event) { return event.source !== 'mqtt_dashcam_event'; }));
        }).catch(function(err) {
            var msg = err && err.message ? err.message : String(err);
            setError(msg);
            notify("Get health events failed: " + msg, { type: "error" });
        }).finally(function() {
            setLoading(false);
        });
    }

    React.useEffect(() => {
        fetchEvents();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [record && record.device_id]);

    function handleDownloadCsv() {
        var csv = buildHealthEventsCsv(events);
        triggerCsvDownload((record.device_id || "device") + "_health_events.csv", csv);
    }

    function handleDelete(event) {
        var eventId = event.id || event._id;
        if (!window.confirm("Delete this health event? This cannot be undone.")) {
            return;
        }
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        setDeletingId(eventId);
        axios.delete(apiBaseUrl + "/device-events/" + encodeURIComponent(eventId), {
            headers: { "x-access-token": token }
        }).then(function() {
            setEvents(function(prev) {
                return prev.filter(function(e) { return (e.id || e._id) !== eventId; });
            });
            notify("Health event deleted", { type: "success" });
        }).catch(function(err) {
            var msg = err && err.message ? err.message : String(err);
            notify("Delete event failed: " + msg, { type: "error" });
        }).finally(function() {
            setDeletingId(null);
        });
    }

    function handleClearAll() {
        if (!record || !record.device_id) return;
        if (!window.confirm("Clear all health events for " + record.device_id + "? This cannot be undone.")) {
            return;
        }
        const token = inMemoryJWT.getToken();
        if (!token) {
            notify("No token found", { type: "error" });
            return;
        }
        setClearing(true);
        axios.post(apiBaseUrl + "/device_events/clear", { device_id: record.device_id }, {
            headers: { "Content-Type": "application/json", "x-access-token": token }
        }).then(function() {
            setEvents([]);
            notify("Health events cleared", { type: "success" });
        }).catch(function(err) {
            var msg = err && err.message ? err.message : String(err);
            notify("Clear events failed: " + msg, { type: "error" });
        }).finally(function() {
            setClearing(false);
        });
    }

    if (!record) return null;

    return (
        <div>
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <Button variant="outlined" size="small" disabled={events.length === 0} onClick={handleDownloadCsv}>
                    Download CSV
                </Button>
                <Button variant="outlined" color="error" size="small" disabled={events.length === 0 || clearing} onClick={handleClearAll}>
                    {clearing ? "Clearing..." : "Clear All"}
                </Button>
            </div>
            <TableContainer component={Paper}>
                {loading && <div style={{ padding: "12px" }}>Loading...</div>}
                {!loading && error && <div style={{ color: "#b00020", padding: "12px" }}>{error}</div>}
                {!loading && !error && events.length === 0 && <div style={{ padding: "12px" }}>No health events</div>}
                {!loading && !error && events.length > 0 && (
                    <Table sx={{ minWidth: 650 }} aria-label="health events table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Event Type</TableCell>
                                <TableCell>Issue</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Created</TableCell>
                                <TableCell>Resolved</TableCell>
                                <TableCell>Message</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {events.map(function(event) {
                                var eventId = event.id || event._id;
                                return (
                                    <TableRow key={eventId}>
                                        <TableCell>{event.event_type}</TableCell>
                                        <TableCell>{formatHealthIssueLabel(event.issue_type)}</TableCell>
                                        <TableCell>{event.status}</TableCell>
                                        <TableCell>{formatHealthTime(event.created_at)}</TableCell>
                                        <TableCell>{formatHealthTime(event.resolved_at)}</TableCell>
                                        <TableCell>{event.message || "-"}</TableCell>
                                        <TableCell>
                                            <Button variant="text" color="error" size="small"
                                                disabled={deletingId === eventId}
                                                onClick={function() { handleDelete(event); }}>
                                                {deletingId === eventId ? "Deleting..." : "Delete"}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                )}
            </TableContainer>
        </div>
    );
}

function getSnapshotChannels(record) {
    var recEn = parseInt(record && record.rec_en != undefined ? record.rec_en : 0, 10);
    if (isNaN(recEn) || recEn <= 0) {
        return [];
    }
    var channels = [];
    for (var i = 0; i < 8; i++) {
        if ((recEn & (1 << i)) !== 0) {
            channels.push(i + 1);
        }
    }
    return channels;
}

function findSnapshotChannelStatus(snapshotStatus, channel) {
    if (!snapshotStatus || !snapshotStatus.channels) {
        return null;
    }
    for (var i = 0; i < snapshotStatus.channels.length; i++) {
        var entry = snapshotStatus.channels[i];
        if (parseInt(entry.channel, 10) === parseInt(channel, 10)) {
            return entry;
        }
    }
    return null;
}

function formatSnapshotTime(value) {
    if (!value) {
        return "-";
    }
    var date = new Date(value);
    if (isNaN(date.getTime())) {
        return String(value);
    }
    return date.toLocaleString();
}

function formatSnapshotConfidence(value) {
    if (value === null || value === undefined || value === "") {
        return "-";
    }
    var numberValue = parseFloat(value);
    if (isNaN(numberValue)) {
        return String(value);
    }
    return numberValue.toFixed(3);
}

function buildLatestSnapshotImageUrl(record, channel, channelStatus, token) {
    if (!record || !record.device_id || !token || !channelStatus || !channelStatus.lastImagePath) {
        return "";
    }
    var url = apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/channels/" + encodeURIComponent(channel) + "/latest-snapshot/image?token=" + encodeURIComponent(token);
    var cacheKey = channelStatus && (channelStatus.lastSnapshotId || channelStatus.updatedAt || channelStatus.lastSnapshotAt);
    if (cacheKey) {
        url += "&_=" + encodeURIComponent(cacheKey);
    }
    return url;
}

function SnapshotCameraCard(props) {
    const record = props.record;
    const channel = props.channel;
    const channelStatus = props.channelStatus;
    const token = props.token;
    const imageUrl = buildLatestSnapshotImageUrl(record, channel, channelStatus, token);
    const [imageError, setImageError] = React.useState(false);

    React.useEffect(() => {
        setImageError(false);
    }, [imageUrl]);

    var cameraName = channelStatus && channelStatus.cameraName ? channelStatus.cameraName : "Camera " + channel;
    var status = channelStatus && channelStatus.status ? channelStatus.status : "unknown";
    var timestamp = channelStatus && channelStatus.lastSnapshotAt ? channelStatus.lastSnapshotAt : null;

    return (
        <Card style={{ padding: "12px", borderRadius: 4 }}>
            <div style={{ fontWeight: 600, marginBottom: "8px" }}>{cameraName}</div>
            <div style={{ width: "100%", aspectRatio: "16 / 9", background: "#f5f5f5", border: "1px solid #ddd", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                {imageUrl && !imageError ? (
                    <img
                        src={imageUrl}
                        alt={"Camera " + channel}
                        style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }}
                        onError={() => setImageError(true)}
                    />
                ) : (
                    <span style={{ color: "#666" }}>No snapshot</span>
                )}
            </div>
            <div style={{ marginTop: "10px", fontSize: "14px", lineHeight: "1.6" }}>
                <div><strong>Timestamp:</strong> {formatSnapshotTime(timestamp)}</div>
                <div><strong>Status detected:</strong> {status}</div>
                <div><strong>Analysis:</strong> {formatSnapshotTime(channelStatus && channelStatus.lastAnalysisAt)}</div>
                <div><strong>Confidence:</strong> {formatSnapshotConfidence(channelStatus && channelStatus.confidence)}</div>
            </div>
        </Card>
    );
}

function SnapshotTab() {
    const record = useRecordContext();
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [snapshotStatus, setSnapshotStatus] = React.useState(null);

    React.useEffect(() => {
        if (!record || !record.device_id) return;
        const token = inMemoryJWT.getToken();
        if (!token) {
            setError("No token found");
            return;
        }
        setLoading(true);
        setError(null);
        setSnapshotStatus(null);
        axios.get(apiBaseUrl + "/devices/" + encodeURIComponent(record.device_id) + "/snapshot-status", {
            headers: {
                "x-access-token": token
            }
        }).then(function (response) {
            var data = response && response.data ? response.data : null;
            if (!data || data.success === false) {
                var message = data && data.error ? data.error : "Invalid response";
                setError(message);
                return;
            }
            setSnapshotStatus(data.snapshotStatus || {});
        }).catch(function (err) {
            var msg = err && err.message ? err.message : String(err);
            setError(msg);
            notify("Get snapshot status failed: " + msg, { type: "error" });
        }).finally(function () {
            setLoading(false);
        });
    }, [record, notify]);

    if (!record) return null;

    var channels = getSnapshotChannels(record);
    var token = inMemoryJWT.getToken();

    return (
        <div style={{ padding: "8px 0" }}>
            <div style={{ marginBottom: "12px" }}>rec_en: {record.rec_en != undefined && record.rec_en !== "" ? record.rec_en : "-"}</div>
            {loading && <div style={{ marginBottom: "12px" }}>Loading...</div>}
            {!loading && error && <div style={{ color: "#b00020", marginBottom: "12px" }}>{error}</div>}
            {channels.length === 0 && <div>No snapshot cameras enabled by rec_en.</div>}
            {channels.length > 0 && (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "16px", alignItems: "start" }}>
                    {channels.map(function (channel) {
                        var channelStatus = findSnapshotChannelStatus(snapshotStatus, channel);
                        return <SnapshotCameraCard key={channel} record={record} channel={channel} channelStatus={channelStatus} token={token} />;
                    })}
                </div>
            )}
        </div>
    );
}

/* https://marmelab.com/react-admin/ShowTutorial.html */
export const DeviceShow = () => (
    <Show>
	    <TabbedShowLayout>
		    <TabbedShowLayout.Tab label="Summary">
{/*
			    <TextField label="Device ID" source="device_id" />
			    <TextField label="Last update" source="last_update_ts" />
			    <TextField label="SN" source="sn" />
			    <TextField label="CPU ID" source="cpu_id" />
			    <TextField label="MAC" source="mac" />
			    <TextField label="IMEI" source="imei" />
			    <TextField label="SIM Present" source="sim" />
			    <TextField label="SIM ID" source="iccid" />
			    <TextField label="FW Version" source="app_ver" />
			    <TextField label="AI Version" source="ai_ver" />
			    <TextField label="MCU Version" source="mcu_ver" />
			    <TextField label="APN" source="apn" />
			    <TextField label="Internet Status" source="internet" />
			    <TextField label="Uptime" source="uptime_str" />
			    <TextField label="CPU Temp" source="cpu_temp" />
			    <TextField label="System Voltage" source="system_voltage" />
			    <TextField label="WiFI IP" source="wifi_ip" />
			    <TextField label="Modem IP" source="lte_ip" />
			    <TextField label="Modem Signal" source="rssi" />
			    <TextField label="Modem Network" source="network_tech" />
			    <TextField label="GPS Lock" source="gps_lock" />
			    <TextField label="GPS Satellite" source="sat" />
*/}
			    <GrafanaUrl />
			    <DeviceHealthSummary />
			    <DeviceCalibrationSummary />
			    <BasicTable />
		    </TabbedShowLayout.Tab>
		    <TabbedShowLayout.Tab label="Snapshot">
			    <SnapshotTab/>
		    </TabbedShowLayout.Tab>
		    <TabbedShowLayout.Tab label="Control">
			    <RebootButton />
			    <FormatSDCardButton />
			    <FactoryResetButton />
		    </TabbedShowLayout.Tab>
		    <TabbedShowLayout.Tab label="Firmware Upgrade">
			    <FirmwareUpgrade/>
		    </TabbedShowLayout.Tab>
		    <TabbedShowLayout.Tab label="Default password">
			    <DefaultPasswordsTab/>
		    </TabbedShowLayout.Tab>
		    <TabbedShowLayout.Tab label="Health Events">
			    <DeviceHealthEventsTab/>
		    </TabbedShowLayout.Tab>
		    <TabbedShowLayout.Tab label="GSensor">
			    <DeviceCalibrationSummary />
			    <GsensorCalibrationRestartButton style={{ marginBottom: "16px" }} />
			    <DeviceCalibrationBackupTab/>
			    <DeviceGsensorEventsTab/>
		    </TabbedShowLayout.Tab>
		    <TabbedShowLayout.Tab label="Configuration">
			    <DeviceConfigurationTab/>
		    </TabbedShowLayout.Tab>
		    <TabbedShowLayout.Tab label="Notification Settings">
			    <DeviceNotificationConfigTab/>
		    </TabbedShowLayout.Tab>
		    <TabbedShowLayout.Tab label="Tasks">
			    <DeviceTaskList/>
		    </TabbedShowLayout.Tab>
	    </TabbedShowLayout>
    </Show>
);
